<template>
    <ul class="base-list-ul">
        <li 
            class="base-list-li" 
            v-for="v in list.content.list"
            :key="v.id" 
        >
            <div class="base-list-image">
                <img :src="v.image">
            </div>
            <h3 class="base-list-li-title" v-html="v.title"></h3>
            <div class="base-list-text_box" >
                <p 
                    class="base-list-text" 
                    v-for="text in v.texts" 
                    :key="text.id"
                >
                    {{text.str}}
                </p>
            </div>
        </li>
        <li class="flex-space-between-fix"></li>
    </ul>
</template>
<script>
// import jquery from 'jquery'

export default {
    name: 'BaseListUlmoudle1',
    props: {
        list: Object
    },
    data: function() {
        return {

        }
    },
    updated: function() {

    },
    mounted() {

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>



</style>